import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TranslationLoaderResolver } from '@shared/services/translation-loader-resolver.service';

import { ProductDetailsContainerComponent } from './containers/product-details-container/product-details-container.component';
import { ResultsContainerComponent } from './containers/results-container/results-container.component';
import { SearchContainerComponent } from './containers/search-container/search-container.component';

const routes: Routes = [
  {
    path: 'product-details/:id',
    data: { hasBanner: true },
    component: ProductDetailsContainerComponent,
  },
  {
    path: '',
    data: { searchLayout: true, hasBanner: true },
    component: SearchContainerComponent,
    resolve: { translation: TranslationLoaderResolver },
    children: [
      {
        path: '',
        component: ResultsContainerComponent,
      },
    ],
  },

  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchRoutingModule {}
